import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import { Tab } from "../../../Reusablecomponents/Tab";
import { UIModal } from "../../../Reusablecomponents/UIModal";
import { ReactComponent as Filter } from "../../../assets/images/filter-svgrepo-com (1).svg";
import {
  Badge,
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Tooltip,
  Space,
  Spin,
} from "antd";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import { ReactComponent as Active } from "../../../assets/images/Group 1000004608 (1).svg";
import { ReactComponent as Inactive } from "../../../assets/images/Group 1000004609 (1).svg";
import { ReactComponent as EditIcon } from "../../../assets/images/Editicon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete-icon.svg";
import GridBuilder from "../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../Reusablecomponents/ReusableDrawer";
import Consignordetails from "./Consignordetails";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { useLocation, useNavigate } from "react-router-dom";
import LocationPicker from "../../../Reusablecomponents/LocationPicker/LocationPicker";
export const WrapperBox = styled.div`
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 480px) {
    .consingment_container {
      display: flex;
      flex-direction: column;
    }
    .consingment_container_two {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 10px;
      justify-content: flex-end;
      margin: 20px 0px 08px 0px;
    }
    p {
      margin-right: auto;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }

    .consingment_container {
      display: flex;
      flex-direction: column;
    }
  }

  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    border: none;
    outline: none;
    background-color: rgb(44, 150, 61);
    color: white;
    border-radius: 19px;
    padding: 15px 24px 15px 24px;
    font-size: 16px;
  }
  .Create_btn {
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }
  .select_dropdown_container .ant-select-selector {
    border-radius: 19px !important;
    width: 250px !important;
  }
  .Creating_Consignor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0px 45px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 9px 8px;
  }
  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
  .inactive-status {
    color: #f20000;
  }
  .active-status {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .status-indicator {
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #78e38a;
    border: 1px solid #2c963d;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .status-indicator::before {
    content: "";
    width: 4px;
    height: 4px;
    background-color: #c2f7cb;
    border-radius: 50%;
  }
`;

const EntityManagement = () => {
  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const countryList = useSelector((state) => state?.authTracking?.countryList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const navigate = useNavigate();

  const tabItems = [
    {
      key: 1,
      label: "Consignor",
    },
    {
      key: 2,
      label: "Transporter",
    },
    {
      key: 3,
      label: "Consignee",
    },
  ];
  const [initialLocation, setInitialLocation] = useState(null);
  const [consignee, setConsignee] = useState({});
  const [hoveredrow, setHoveredrow] = useState(null);
  const [drawyeropen, setDrawyeropen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [entityData, setEntityData] = useState(false);
  const [isView, setIsView] = useState(false);
  const [tabId, setTabId] = useState(1);
  const [townList, setTownList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({
    entityname: "",
    entitycode: "",
  });
  const [formData, setFormData] = useState({
    Consignorcode: "",
    Consignorname: "",
    Country: "",
    town: "",
    Contactperson: "",
    phone: "",
    Mobile: "",
    Countrycode: "",
    Email: "",
    Physicalocation: "",
    switch: false,
    TripAvgtime: "",
  });
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const createAllowed = useMemo(
    () => hasPermission("CENTITY", "C"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("CENTITY", "U"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("CENTITY", "D"),
    [reduxPermissions],
  );
  const TcreateAllowed = useMemo(
    () => hasPermission("TENTITY", "C"),
    [reduxPermissions],
  );
  const TupdateAllowed = useMemo(
    () => hasPermission("TENTITY", "U"),
    [reduxPermissions],
  );
  const TdeleteAllowed = useMemo(
    () => hasPermission("TENTITY", "D"),
    [reduxPermissions],
  );
  const CecreateAllowed = useMemo(
    () => hasPermission("CE_ENTITY", "C"),
    [reduxPermissions],
  );
  const CeupdateAllowed = useMemo(
    () => hasPermission("CE_ENTITY", "U"),
    [reduxPermissions],
  );
  const CedeleteAllowed = useMemo(
    () => hasPermission("CE_ENTITY", "D"),
    [reduxPermissions],
  );
  const isCreateAllowed =
    tabId === 1
      ? createAllowed
      : tabId === 2
        ? TcreateAllowed
        : tabId === 3
          ? CecreateAllowed
          : false;
  const isUpdateAllowed =
    tabId === 1
      ? updateAllowed
      : tabId === 2
        ? TupdateAllowed
        : tabId === 3
          ? CeupdateAllowed
          : false;
  const isDeleteAllowed =
    tabId === 1
      ? deleteAllowed
      : tabId === 2
        ? TdeleteAllowed
        : tabId === 3
          ? CedeleteAllowed
          : false;
  useEffect(() => {
    // Set form values
    form.setFieldsValue({
      Consignorcode: formData?.ENTCODE,
      Consignorname: formData?.ENTNAME,
      Country: formData?.COUNTRY,
      town: formData?.TID,
      Contactperson: formData?.CONTACTPERSON,
      phone: formData?.PHONE,
      Countrycode: formData?.Mobile,
      Mobile: formData?.Mobile,
      Email: formData?.EMAIL,
      Physicalocation: formData?.ADDRESS,
      TripAvgtime: "",
      ENTID: formData?.ENTID,
      MCID: formData?.MCID,
      switch: false, // if you use a Switch component
    });
  }, [drawyeropen]);

  useEffect(() => {
    let countryCode = countryList?.find((e) => {
      return e?.ID === formData.Country;
    });
    if (countryCode) {
      setFormData((prev) => ({
        ...prev,
        Countrycode: countryCode?.CountryCode || "",
      }));
    }
  }, [formData.Country, countryList]);

  //Pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [entitytotal, setEntityTotal] = useState(0);
  const [entityCurrentPage, setEntityCurrentPage] = useState(1);
  const [entitypageSize, setEntityPageSize] = useState(10);
  const [filterCount, setFilterCount] = useState(0);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [customFields, setCustomFields] = useState([]);
  const [phonenumberopt, setPhonenumberopt] = useState([]);
  // Handle the search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setEntityCurrentPage(1); // Reset to the first page on search
  };

  const entityPageChange = (page, pageSize) => {
    setEntityCurrentPage(page);
    setEntityPageSize(pageSize);
  };

  const entityPageSizeChange = (value) => {
    setEntityPageSize(value);
    setEntityCurrentPage(1);
  };

  const fetchTownList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getTownByCountryId", {
      countryId: formData?.Country || "",
    });
    setTownList(data);
  };

  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));

    //     if(value === "Country"){
    //   setFormData((prev) => ({
    //   ...prev,
    //   Mobile: countryList?.find((val)=>val?.ID === formData?.Country)?.CountryCode || "", // or any fallback like "" or null

    // }));
    //     }

    if (value === "Country") {
      const mobileCode =
        countryList?.find((val) => val?.ID === formData?.Country) || "";
      const b = mobileCode?.CountryCode;

      setFormData((prev) => ({
        ...prev,
        Mobile: b,
      }));
    }
  };

  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);

  const GetAllCustomeData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Entity`,
      );

      SetAllCustomeData(data);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchEntityData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `entity/getAll?limit=${entitypageSize}&page=${entityCurrentPage}&entType=${tabId}&entName=${filterValues?.entityname}&entCode=${filterValues?.entitycode}`,
        {},
      );
      setPhonenumberopt(data?.data);
      const newData1 = data?.data?.map((entityItem) => {
        const enrichedItem = { ...entityItem };

        // Match fields by REFID === ENTID
        const matchedFields =
          AllCustomeData?.filter((field) => field.REFID === entityItem.ENTID) ||
          [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });
      setEntityData(newData1 || []);
      setEntityTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalEntity] error -->", error);
    }
  };
  //Custome Field api calling Function

  const loadCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Entity",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (EntId, values) => {
    try {
      const customDataList = customFields
        .map((field) => {
          if (!field?.FIELDNAME) return null;

          const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
          const value = values?.[fieldName];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,

              RefId: EntId,
              Value: value,
            };
          }

          return null;
        })
        .filter(Boolean);
      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateCustomeData(data);
    } catch (error) {
      setCreateCustomeData([]);
    }
  };

  //Update custom data api call functionality
  const CustomeDataUpdate = async (EntId, values) => {
    setLoading(true);
    try {
      // Loop through all custom fields
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        const value = values?.[fieldName];

        // Find the existing custom data for this field and entity
        const existing = AllCustomeData?.find(
          (item) => item.REFID === EntId && item.CFID === field.CFID,
        );

        // Only update if value is present and there is an existing record
        if (value !== undefined && value !== "" && existing) {
          const payload = {
            CfId: field.CFID,
            RefId: EntId,
            Value: value,
            DataId: existing.DATAID,
          };

          await CALL_API("PATCH", "mastertable/updateCustomData", payload);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (EntId) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: EntId,
          RefTab: "Entity",
          McId: userInfo?.MCID,
        },
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const getLatLongFromAddress = async (address) => {
  try {
    const { data } = await CALL_API("POST", "common/geocode", { address });
    return {
      latitude: data?.latitude ?? null,
      longitude: data?.longitude ?? null,
    };
    console.log("Geocoding result:", data);
  } catch (error) {
    console.error("Geocoding failed:", error);
    return { latitude: null, longitude: null };
  }
};

  // async function getLatLongFromAddress(address) {
  //   const apiKey = "AIzaSyBQTwxWgTr-EpbmcwmxRVVYwdi8F6sRcg4";
  //   const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
  //     address,
  //   )}&key=${apiKey}`;

  //   const response = await fetch(url);
  //   const data = await response.json();

  //   if (data.status === "OK") {
  //     const location = data.results[0].geometry.location;
  //     return {
  //       latitude: location.lat,
  //       longitude: location.lng,
  //     };
  //   } else {
  //     console.error("Geocoding failed:", data.status);
  //     return {
  //       latitude: null,
  //       longitude: null,
  //     };
  //   }
  // }

  // Example usage:

  const handleSubmitForm = async (values) => {
    const townName = townList?.filter((item) => item?.TID === values?.town);
    const { latitude, longitude } = await getLatLongFromAddress(
      values?.Physicalocation,
    );
    const commonPayload = {
      MCID: userInfo?.MCID,
      ENTTYPE: tabId,
      ENTCODE: values?.Consignorcode,
      ENTNAME: values?.Consignorname,
      ADDRESS: values?.Physicalocation,
      CONTACTPERSON: values?.Contactperson,
      PHONE: values?.phone,
      EMAIL: values?.Email,
      ACTIVE: true,
      COUNTRY: values?.Country,
      //  "LATITUDE": formData?.Physicalocationname?.latitude,
      LATITUDE: latitude?.toString() || null,
      LONGITUDE: longitude?.toString() || null,
      //   "LONGITUDE": formData?.Physicalocationname?.longitude,
      DELETED: false,
      Mobile: values?.Mobile,
      TID: values?.town,
      TOWNNAME: townName?.[0]?.TOWNNAME || null,
      CRBY: userInfo.UID,
    };

    const updatePayload = {
      ...commonPayload,
      ENTID: formData?.ENTID,
      MCID: formData?.MCID, // Preserve original MCID during edit
    };

    setCreateLoading(true);

    try {
      const {
        ResponseCode,
        message: msg,
        data,
      } = await CALL_API(
        isEdit ? "PATCH" : "POST",
        isEdit ? "entity/update" : "entity/insert",
        isEdit ? updatePayload : commonPayload,
      );

      if (ResponseCode !== 200) {
        message.error(
          "A entity with the same name or code already exists. Please use a unique value." ||
            "An error occurred while processing the request.",
        );
        return;
      }

      // Extract EntId based on API response

      const EntId = isEdit
        ? formData?.ENTID
        : data?.EntId || data?.ENTID || data?.result?.ENTID;
      if (EntId) {
        if (!isEdit) {
          await CustomeDataCreate(EntId, values);
        } else {
          await CustomeDataUpdate(EntId, values);
        }
      }

      message.success(
        isEdit
          ? "Entity Updated Successfully!"
          : "Entity Created Successfully!",
      );

      handleClose();

      GetAllCustomeData();
      fetchEntityData();
      setIsEdit(false);
    } catch (error) {
      if (error.response) {
        const { status, data: errData } = error.response;

        const errMsg = errData?.message?.toLowerCase?.() || "";

        if (
          status === 400 &&
          (errMsg.includes("same name") || errMsg.includes("same code"))
        ) {
          message.error(
            "A consignor with the same name or code already exists. Please use a unique value.",
          );
          return;
        }

        message.error(
          errData.message || "You are not authorized to perform this action.",
        );
        return;
      }
      message.error("Network or unexpected error, please try again.");
    } finally {
      setCreateLoading(false);
    }
  };

  const filterData =
    entityData?.length > 0
      ? entityData?.filter((item) => item?.ENTTYPE === tabId)
      : [];

  useEffect(() => {
    fetchEntityData();
  }, [entitypageSize, entityCurrentPage, tabId, filterValues]);

  useEffect(() => {
    loadCustomFields();
    GetAllCustomeData();
  }, []);

  //pickup map location
  const location = useLocation();

  // Check if returning from GeoDetails and restore drawer/form state
  useEffect(() => {
    // Check if we're returning from GeoDetails with fromEntityManagement flag
    if (
      location.state?.returnFromGeoDetails &&
      location.state?.entityFormData
    ) {
      // Open the drawer
      setDrawyeropen(true);
      // Restore the original create/edit mode (default to false if not provided)
      setIsEdit(location.state?.entityIsEdit ?? false);

      // Restore the tab
      if (location.state.entityTabId) {
        setTabId(location.state.entityTabId);
      }

      // Restore form data
      const savedFormData = location.state.entityFormData;
      form.setFieldsValue(savedFormData);

      // Also update formData state if needed
      setFormData((prev) => ({
        ...prev,
        ...savedFormData,
      }));

      // Clear the location state to prevent reopening on subsequent renders
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, form, navigate, location.pathname]);

  useEffect(() => {
    if (formData?.Country !== "") {
      fetchTownList();
    }
  }, [formData?.Country]);
  const [locationModal, setLocationModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const locationClick = (name, initialLocation = null) => {
    setSelectedItem(name);
    setInitialLocation(initialLocation);
    setLocationModal(true);
  };

  const handleLocationSelect = (location) => {
    setFormData((prev) => ({
      ...prev,
      [selectedItem]: location.place_name,
      [`${selectedItem}name`]: {
        place_name: location.place_name,
        latitude: location?.center[0],
        longitude: location?.center[1],
      },
    }));

    setLocationModal(false);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    setFormData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };

  const handletextmobile = (e) => {
    const { value, name } = e.target;

    const typed = e.target.value;
    const parts = typed.split("-").map((part) => part.trim());
    const country = parts[0] || "";
    const phone = parts[1] || "";
    const cleanPhone = phone.replace(/\D/g, "");
    setFormData((prev) => ({
      ...prev,
      Countrycode: country,
      Mobile: cleanPhone,
    }));

    setFormData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };

  const handleClickme = (record) => {
    setHoveredrow(record.key);
  };

  const handleClickeditdrawer = async (event, record) => {
    event.stopPropagation();
    setIsEdit(true);
    setDrawyeropen(true);

    await new Promise((resolve) => setTimeout(resolve, 500));
    setFormData({
      Consignorcode: record?.ENTCODE,
      Consignorname: record?.ENTNAME,
      Country: record?.COUNTRY,
      town: record?.TID,
      Contactperson: record?.CONTACTPERSON,
      phone: record?.PHONE,
      // Countrycode: record.Mobile,
      Mobile: record.Mobile,
      Email: record?.EMAIL,
      Physicalocation: record?.ADDRESS,
      switch: false,
      TripAvgtime: "",
      ENTID: record?.ENTID,
      MCID: record?.MCID,
    });

    // Set form values
    form.setFieldValue("Mobile", record?.Mobile);
    // form.setFieldsValue({
    //   Consignorcode: record?.ENTCODE,
    //   Consignorname: record?.ENTNAME,
    //   Country: record?.COUNTRY,
    //   town: record?.TID,
    //   Contactperson: record?.CONTACTPERSON,
    //   phone: record?.PHONE,
    //   // Countrycode: record.Mobile,
    //   Mobile: record.Mobile,
    //   Email: record?.EMAIL,
    //   Physicalocation: record?.ADDRESS,
    //   switch: false,
    //   TripAvgtime: "",
    //   ENTID: record?.ENTID,
    //   MCID: record?.MCID,
    // });
  };

  //   useEffect(()=> {
  // setFormData(formData)
  //   }, [drawyeropen])

  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const dynamicCustomColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) return [];

    return customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME, // ← match raw field name
      key: field.CFID,
      sorter: false,
      render: (text) => text || "-",
    }));
  }, [customFields]);
  const columns = [
    {
      title: "Entity Name",
      dataIndex: "ENTNAME",
      key: "ENTNAME",
      width: "20%",
    },
    {
      title: "Entity Code",
      dataIndex: "ENTCODE",
      key: "ENTCODE",
      width: "20%",
    },
    {
      title: "Email",
      dataIndex: "EMAIL",
      key: "EMAIL",
      width: "20%",
      render: (text) => text || "-",
    },
    {
      title: "Town",
      dataIndex: "TOWNNAME",
      key: "TOWNNAME",
      width: "20%",
      render: (text) => text || "-",
    },
    {
      title: "Status",
      dataIndex: "ACTIVE",
      key: "ACTIVE",
      width: "20%",
      render: (text) =>
        text === true ? (
          <span className="active-status">
            <Active style={{ width: "12px", height: "12px" }} />
            Active
          </span>
        ) : (
          <span className="inactive-status">
            <Inactive style={{ width: "12px", height: "12px" }} />
            Inactive
          </span>
        ),
    },
    {
      title: "",
      dataIndex: "key",
      key: "actions",
      width: 100,
      render: (_, record) => {
        return (
          <div
            className={
              hoveredrow === record.key
                ? "d-flex gap-3 opacity-100"
                : "opacity-0"
            }
          >
            <div style={{ display: "flex", gap: "18px" }}>
              <EditIcon
                style={{
                  cursor: isUpdateAllowed ? "pointer" : "not-allowed",
                }}
                onClick={(event) => {
                  if (!isUpdateAllowed) return;
                  handleClickeditdrawer(event, record);
                }}
              />
              <DeleteIcon
                onClick={(e) => {
                  if (!isDeleteAllowed) return;
                  e?.stopPropagation();
                  setDeleteId(record?.ENTID);
                  setIsDeleteModalVisible(true);
                }}
                style={{
                  cursor: isDeleteAllowed ? "pointer" : "not-allowed",
                }}
              />
            </div>
          </div>
        );
      },
    },
  ];
  const combinedColumns = useMemo(() => {
    const staticCols = [...columns];

    if (!customFields || customFields.length === 0) return staticCols;

    const dynamicCols = customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME,
      key: field.CFID,
      sorter: false,
      render: (_, record) => record?.[field.CFID] ?? "-",
    }));

    return [...staticCols, ...dynamicCols];
  }, [columns, customFields]);

  const handleDelete = async (id) => {
    try {
      setLoading(true);

      await CALL_API("GET", `entity/delete?id=${id}`);

      await CustomeDataDelete(id);

      if (message.success) {
        message.success("Entity Deleted Successfully");
        setIsView(false);
      } else {
      }
      fetchEntityData();
    } catch (error) {
      console.error("Error during deletion:", error);
    } finally {
      setLoading(false);
    }
  };

  const [formType, setFormType] = useState("addEdit");
  const handleOpen = () => {
    setFormType("addEdit");
    setDrawyeropen(true);
    loadCustomFields();
  };
  const handleClose = () => {
    setDrawyeropen(false);
    setIsEdit(false);
    setFormData({
      Consignorcode: "",
      Consignorname: "",
      Country: "",
      town: "",
      Contactperson: "",
      phone: "",
      Countrycode: "",
      Mobile: "",
      Email: "",
      Physicalocation: "",
      switch: false,
      TripAvgtime: "",
    });
    form.resetFields();
  };
  const handleOutsideClose = () => {
    setDrawyeropen(false);
  };

  const footerStyle = {
    position: "sticky", // Keep it inside the modal without breaking layout
    bottom: 0,
    left: 0,
    width: "100%", // Ensure it stretches across the modal
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "flex-end",
    // boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
    zIndex: 10, // Ensure it stays above content
  };

  const AddEditFormm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      [
        {
          id: 1,
          label:
            tabId === 1
              ? "Consignor Code"
              : tabId === 2
                ? "Transporter Code"
                : "Consignee Code",
          type: "text",
          name: "Consignorcode",
          placeholder: "AAR1234",
          value: formData.Consignorcode,
          onChange: handleChange,
          // onKeyDown: /^[0-9]$/,
          maxLength: 10,
          style: "",
          validationRules: [
            { required: true, message: "Consignor Code is required" },
          ],
        },
        {
          id: 2,
          label:
            tabId === 1
              ? "Consignor Name"
              : tabId === 2
                ? "Transporter Name"
                : "Consignee Name",
          type: "text",
          name: "Consignorname",
          placeholder: "AAR1234",
          value: formData.Consignorname,
          onChange: handleChange,
          maxLength: 50,
          // onKeyDown: /^[A-Za-z\s]+$/,
          style: "",
          validationRules: [
            { required: true, message: "Consignor Name is required" },
          ],
        },
        {
          id: 3,
          label: "Country",
          type: "selectwithvalue",
          name: "Country",
          placeholder: "India",
          value: formData.Country,
          options: countryList?.map((item) => ({
            label: item?.NAME,
            value: item?.ID,
          })),
          onChange: (value) => {
            const selectedCountry = countryList?.find(
              (item) => item?.ID === value,
            );
            const countryIso = selectedCountry?.ISOCode2?.toLowerCase(); // Needed for flag
            const callingCode = selectedCountry?.Countrycode; // e.g., +91

            const formattedMobile = callingCode || "";

            setFormData((prevData) => ({
              ...prevData,
              Country: value,
              Countrycode: callingCode,
              CountryISO: countryIso,
              Mobile: formattedMobile, // This updates the PhoneInput
            }));

            // form.setFieldsValue({
            //   Mobile: formattedMobile,
            // });
          },
          style: "",
          validationRules: [{ required: true, message: "Country is required" }],
        },
        {
          id: 4,
          label: "Town",
          type: "selectwithvalue",
          name: "town",
          placeholder: "Chennai",
          // disabled: townList?.length === 0,
          options: townList?.map((item) => ({
            label: item?.TOWNNAME || "",
            value: item?.TID || "",
          })),
          style: "",
          validationRules: [{ required: false, message: "Town is required" }],
        },
      ],
      [
        {
          id: 5,
          label: "Contact Person",
          type: "text",
          name: "Contactperson",
          placeholder: "3",
          value: formData.Contactperson,
          maxLength: 30,
          onKeyDown: /^[A-Za-z\s]+$/,
          onChange: handleChange,
          style: "",
        },
        {
          id: 6,
          label: "Phone",
          type: "text",
          name: "phone",
          placeholder: "",
          // disabled: true,
          value: formData.phone,
          onChange: handleChange,
          style: "",
          onKeyDown: /^[0-9]+$/,
          maxLength: 14,
        },
        // {
        //   id: 7,
        //   label: "Mobile (with Country Code)",
        //   type: "phone",
        //   name: "Mobile",
        //   placeholder: "e.g., +91XXXXXXXXXX",
        //   validationRules: [
        //     { required: true, message: "Mobile number is required" },
        //     { pattern: /^[0-9+]+$/, message: "Enter a valid mobile number" },
        //   ],
        // },
        {
          id: 7,
          label: "Mobile (with Country Code)",
          type: "text",
          name: "Mobile",
          placeholder: "+321 - 9877336333",
          // value: `${formData.Countrycode } - ${formData.Mobile}`,
          value: formData.Mobile,

          //  onChange: (e) => {
          //   const typed = e.target.value;
          //   const parts = typed.split("-").map((part) => part.trim());
          //   const country = parts[0] || "";
          //   const phone = parts[1] || "";
          //   const cleanPhone = phone.replace(/\D/g, "");

          //   setFormData((prev) => ({
          //     ...prev,
          //     Countrycode: country,
          //     Mobile: cleanPhone,
          //   }));
          // },

          onChange: handletextmobile,

          validationRules: [
            {
              required: false,
              message: "Enter a valid mobile number",
            },
            {
              pattern: /^\+\d{1,4}[-\d]{10,15}$/,
              message: "Enter a valid mobile number (e.g., +91-1234567890)",
            },
          ],
        },
        {
          id: 8,
          label: "Email",
          type: "email",
          name: "Email",
          placeholder: "hello@gmail.com",
          value: formData.Email,
          onChange: handleChange,
          style: "",
          validationRules: [
            {
              required: false,
              message: `Email ID is required`,
            },
            {
              pattern: /^\S+@\S+\.\S+$/,
              message: "valid email address is required",
            },
          ],
        },
      ],
      [
        {
          id: 9,
          label: "Physical Location",
          type: "location",
          name: "Physicalocation",
          placeholder: "",
          value: "",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Location is required" },
          ],
        },
        {},
      ],
      [
        {
          id: 11,
          label: "Trip Avg Time (Minutes)",
          type: "text",
          name: "TripAvgtime",
          placeholder: "",
          value: formData.TripAvgtime,
          disabled: true,
          onChange: handleChange,
          style: "",
        },
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData, townList, countryList]);

  const handleclick = (record) => {
    setConsignee(record);
    setIsView(true);
  };

  const handleTabChange = (activeKey) => {
    setTabId(activeKey);
  };

  return (
    <>
      {isView ? (
        <>
          <Consignordetails
            setDrawyeropen={setDrawyeropen}
            AddEditFormm={AddEditFormm}
            handleChange={handleChange}
            handleSubmitForm={handleSubmitForm}
            handleClose={handleClose}
            drawyeropen={drawyeropen}
            formData={formData}
            WrapperBox={WrapperBox}
            consignee={consignee}
            setIsView={setIsView}
            setIsEdit={setIsEdit}
            setFormData={setFormData}
            handleDelete={handleDelete}
            dloading={loading}
            isDeleteAllowed={isDeleteAllowed}
            isUpdateAllowed={isUpdateAllowed}
          />
        </>
      ) : (
        <>
          <Row gutter={16}>
            <Col xs={24} xl={24}>
              <Tab
                defaultActiveKey=""
                items={tabItems}
                onChange={handleTabChange}
              />
            </Col>
          </Row>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <div className="consingment_container">
                  <p>
                    {entitytotal}{" "}
                    {tabId === 1
                      ? "Consignors"
                      : tabId === 2
                        ? "Transporters"
                        : "Consignees"}
                  </p>{" "}
                  <div className="consingment_container_two">
                    <Button
                      className="rounded-circle border"
                      onClick={() => setFilterModalOpen(true)}
                    >
                      <Space size="middle">
                        <Badge size="small" count={filterCount}>
                          <Filter />{" "}
                        </Badge>
                      </Space>
                    </Button>
                    <Tooltip title={!isCreateAllowed ? "No permission" : ""}>
                      <ButtonOutlined
                        onClick={handleOpen}
                        className="Create_btn"
                        disabled={!isCreateAllowed}
                      >
                        + Create
                      </ButtonOutlined>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </WrapperBox>

          <WrapperBox>
            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <Spin spinning={loading}>
                  {filterData.length > 0 && (
                    <StyledTable
                      pagination={false}
                      dataSource={filterData || []}
                      columns={combinedColumns}
                      onRow={(record) => ({
                        onClick: (e) => {
                          e.stopPropagation();
                          handleclick(record);
                        },
                        onMouseEnter: () => setHoveredrow(record.key),
                        onMouseLeave: () => setHoveredrow(null),
                      })}
                    />
                  )}
                  <ReusablePagination
                    pageSize={entitypageSize}
                    handlePageSizeChange={entityPageSizeChange}
                    currentPage={entityCurrentPage}
                    total={entitytotal}
                    handlePageChange={entityPageChange}
                  />
                </Spin>
              </Col>
            </Row>
          </WrapperBox>
        </>
      )}
      <ReusableDrawer
        title=""
        open={drawyeropen}
        setOpen={setDrawyeropen}
        // onClose={handleOutsideClose}
        onClose={() => {}}
        closable={false}
        maskClosable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={handleClose}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <Tooltip
              title={
                isEdit
                  ? !updateAllowed
                    ? "No permission"
                    : ""
                  : !createAllowed
                    ? "No permission"
                    : ""
              }
            >
              <ButtonFilled
                key="create"
                type="primary"
                onClick={() => form.submit()}
                loading={createLoading}
                disabled={isEdit ? !updateAllowed : !createAllowed}
              >
                {isEdit ? "Update" : "Create"}
              </ButtonFilled>
            </Tooltip>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignor">
                <p>
                  {isEdit
                    ? `Modifying ${
                        tabId === 1
                          ? "Consignor"
                          : tabId === 2
                            ? "Transporter"
                            : "Consignee"
                      }`
                    : `Creating ${
                        tabId === 1
                          ? "Consignor"
                          : tabId === 2
                            ? "Transporter"
                            : "Consignee"
                      }`}
                </p>
                <span>{/* <CloseOutlined onClick={handleClose} /> */}</span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                handleSelectChange={handleSelectChange}
                initialValues={formData}
                form={form}
                locationClick={locationClick}
                selectedCountry={formData.Country}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this Entity?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              loading={loading}
              onClick={() => {
                handleDelete(deleteId); // Call the delete function with the selected ID
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              setFilterValues({ entityname: "", entitycode: "" });
              filterform?.setFieldsValue({ entityname: "", entitycode: "" });
              setFilterCount(0);
              setFilterModalOpen(false);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Form
          form={filterform}
          layout="vertical"
          onValuesChange={(value, allvalues) => {
            const count = Object.values(allvalues).filter(
              (val) =>
                val !== undefined && val !== null && String(val).trim() !== "",
            ).length;

            setFilterCount(count);
            setFilterValues(allvalues);
          }}
          initialValues={filterValues}
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Entity Code" name="entitycode">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Entity Name" name="entityname">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <LocationPicker
        visible={locationModal}
        onClose={() => {
          setLocationModal(false);
          setInitialLocation(null);
        }}
        onSelect={handleLocationSelect}
        initialLocation={initialLocation}
      />
    </>
  );
};

export default EntityManagement;
